import React from 'react';
import familyVideo from '../../assets/videos/family.mp4';

const Header = () => {
  const whatsappLink = 'https://wa.me/917020113728?text=Hello%20Shravi%20Finance%2C%20I%20want%20to%20apply%20for%20a%20loan.';

  return (
    <header id="home" className="bg-gradient-to-br from-primary-800 via-primary-900 to-primary-950 text-white pt-24 pb-20 relative overflow-hidden">
      {/* Yellow strip at top */}
      <div className="w-full h-20 bg-yellow-400 absolute top-0 left-0 z-20"></div>
      
      {/* Decorative background elements */}
      <div className="absolute inset-0 opacity-10" style={{ willChange: 'transform' }}>
        <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl" style={{ willChange: 'transform' }}></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl" style={{ willChange: 'transform' }}></div>
      </div>
      
      <div className="max-w-8xl mx-auto px-4 sm:px-4 lg:px-6 relative z-10">
        {/* Instant Loan Banner */}
        <div className="mb-6 md:mb-8 bg-white/20 backdrop-blur-sm rounded-xl md:rounded-2xl p-3 md:p-6 border border-white/30 shadow-xl" style={{ willChange: 'transform' }}>
          <div className="flex flex-col md:flex-row items-center justify-between gap-3 md:gap-4">
            <div className="flex items-center gap-2 md:gap-4 w-full md:w-auto">
              <div className="bg-white/30 rounded-full p-2 md:p-4 flex-shrink-0">
                <svg className="w-6 h-6 md:w-8 md:h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-base sm:text-lg md:text-2xl lg:text-3xl font-bold mb-1 flex flex-wrap items-center gap-1 md:gap-2">
                  <span className="text-xs sm:text-sm md:text-base">⚡तुरंत लोन 24 घंटे में |</span>
                  <span className="instant-loan-glass text-yellow-400 font-extrabold text-lg sm:text-xl md:text-3xl lg:text-4xl tracking-wide">
                      INSTANT LOAN
                  </span>
                  <span className="text-xs sm:text-sm md:text-base">in 24 Hours</span>
                </h3>
                <p className="text-xs sm:text-sm md:text-lg text-white/90 mt-1 md:mt-2 leading-tight md:leading-normal">
                  Apply now and get approved within 24 hours | अभी आवेदन करें और 24 घंटे में मंजूरी पाएं
                </p>
              </div>
            </div>
            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white text-black px-4 py-2 md:px-8 md:py-3.5 rounded-lg md:rounded-xl font-bold text-sm md:text-lg hover:bg-primary-50 transition-all transform hover:scale-105 shadow-2xl text-center w-full md:w-auto inline-flex items-center gap-2 md:gap-3 justify-center"
            >
              <span className="bg-[#25D366] rounded-lg p-1 md:p-1.5 flex-shrink-0">
                <svg className="w-4 h-4 md:w-5 md:h-5" fill="white" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 23l5.25-1.38a11.767 11.767 0 005.743 1.494h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
                </svg>
              </span>
              <span className="text-xs md:text-base">Apply for Loan</span>
            </a>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-6 md:gap-8 lg:gap-12 items-center mb-8 md:mb-12 px-2 sm:px-2 lg:px-4">
          {/* Left Content */}
          <div className="space-y-4 md:space-y-6 pr-0 md:pr-4 order-2 md:order-1">
            <div className="space-y-3 md:space-y-4">
              <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold leading-tight text-white break-words">
                <span className="block">
                  Get the Loan You Need, When You Need It
                </span>
                <span className="block mt-2 md:mt-3 text-lg sm:text-xl md:text-2xl lg:text-3xl text-white/90 font-semibold">
                  जब चाहें, तब लोन पाएं
                </span>
              </h1>
            </div>
            
            <div className="space-y-2 md:space-y-3 bg-white/10 backdrop-blur-sm rounded-lg md:rounded-xl p-4 md:p-6 border border-white/20">
              <p className="text-sm sm:text-base md:text-lg lg:text-xl text-white/95 font-medium leading-relaxed">
                Fast, flexible, and reliable financing solutions for your dreams. 
                Experience hassle-free loan processing with Shravi Financial Services.
              </p>
              <p className="text-xs sm:text-sm md:text-base lg:text-lg text-white/85 leading-relaxed">
              आपकी जरूरतों के अनुसार तेज़ और भरोसेमंद फाइनेंसिंग। श्रवी फाइनेंस के साथ आसान लोन प्रक्रिया।
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-3 md:gap-4 pt-2">
              <a
                href={whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white text-black px-6 py-3 md:px-8 md:py-4 rounded-lg md:rounded-xl font-bold text-sm md:text-base lg:text-lg hover:bg-yellow-400 hover:text-primary-950 transition-all transform hover:scale-105 shadow-2xl text-center w-full sm:w-auto flex items-center justify-center gap-2 md:gap-3"
              >
                <div className="bg-[#25D366] rounded-lg p-1 md:p-1.5 flex-shrink-0">
                  <svg className="w-4 h-4 md:w-5 md:h-5" fill="white" viewBox="0 0 24 24">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 23l5.25-1.38a11.767 11.767 0 005.743 1.494h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
                  </svg>
                </div>
                <span>Apply for Loan</span>
              </a>
            </div>
          </div>

          {/* Right Content - Video */}
          <div className="relative rounded-xl md:rounded-2xl overflow-hidden shadow-2xl border-2 md:border-4 border-yellow-400 aspect-video order-1 md:order-2">
            <video 
              autoPlay 
              loop 
              muted 
              playsInline
              preload="metadata"
              className="w-full h-full object-cover"
            >
              <source src={familyVideo} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            {/* Overlay gradient for better text visibility if needed */}
            <div className="absolute inset-0 bg-gradient-to-t from-primary-900/20 to-transparent pointer-events-none"></div>
          </div>
        </div>

        {/* Stats Section - Single Row */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-2 sm:gap-3 md:gap-4 lg:gap-6">
          <div className="bg-white/20 backdrop-blur-md rounded-lg md:rounded-xl p-3 md:p-4 lg:p-6 text-center border border-white/30 shadow-xl hover:bg-white/30 transition-all transform hover:scale-105">
            <div className="stats-number text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-1 md:mb-2 text-yellow-400">24hrs</div>
            <div className="text-white/90 font-semibold text-xs sm:text-sm md:text-base">Quick Approval</div>
            <div className="text-white/80 text-[10px] sm:text-xs md:text-sm mt-0.5 md:mt-1">तेज़ मंजूरी</div>
          </div>
          <div className="bg-white/20 backdrop-blur-md rounded-lg md:rounded-xl p-3 md:p-4 lg:p-6 text-center border border-white/30 shadow-xl hover:bg-white/30 transition-all transform hover:scale-105">
            <div className="stats-number text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-1 md:mb-2 text-yellow-400">15K+</div>
            <div className="text-white/90 font-semibold text-xs sm:text-sm md:text-base">Happy Customers</div>
            <div className="text-white/80 text-[10px] sm:text-xs md:text-sm mt-0.5 md:mt-1">खुश ग्राहक</div>
          </div>
          <div className="bg-white/20 backdrop-blur-md rounded-lg md:rounded-xl p-3 md:p-4 lg:p-6 text-center border border-white/30 shadow-xl hover:bg-white/30 transition-all transform hover:scale-105">
            <div className="stats-number text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-1 md:mb-2 text-yellow-400">₹50Cr+</div>
            <div className="text-white/90 font-semibold text-xs sm:text-sm md:text-base">Loans Disbursed</div>
            <div className="text-white/80 text-[10px] sm:text-xs md:text-sm mt-0.5 md:mt-1">लोन वितरित</div>
          </div>
          <div className="bg-white/20 backdrop-blur-md rounded-lg md:rounded-xl p-3 md:p-4 lg:p-6 text-center border border-white/30 shadow-xl hover:bg-white/30 transition-all transform hover:scale-105">
            <div className="stats-number text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-1 md:mb-2 text-yellow-400">4.9★</div>
            <div className="text-white/90 font-semibold text-xs sm:text-sm md:text-base">Customer Rating</div>
            <div className="text-white/80 text-[10px] sm:text-xs md:text-sm mt-0.5 md:mt-1">ग्राहक रेटिंग</div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;

